(function ($) {
    if (!$) {
        return;
    }

    window.ITConnect.validation = {
        clear($form) {
            $form.find('.form__error').text('');
            $form.find('.is-invalid').removeClass('is-invalid');
        },

        show($form, errors) {
            Object.keys(errors || {}).forEach((name) => {
                $form.find(`[data-error-for="${name}"]`).text(errors[name][0]);
                $form.find(`[name="${name}"]`).addClass('is-invalid');
            });
        },
    };
})(window.jQuery);
